import { Adminauthcontext } from "../Context/Adminauthcontext";
import { useContext } from "react";



export const Adminauthcontexthooks = () => {

    const context = useContext(Adminauthcontext)


    if (!context) {

        throw Error('adminAuthContext must be used inside an AuthcontextProvider')
    }

    return context
}
